import React, { } from 'react';
import { List, Datagrid, TextInput, Filter, FunctionField } from 'react-admin';
import { Create, SimpleForm, SelectInput, required, Edit, SaveButton, Toolbar, EditButton } from 'react-admin';
import { cloneElement } from 'react';
import {
    useListContext,
    TopToolbar,
    CreateButton,
    ExportButton,
    sanitizeListRestProps,
    usePermissions
} from 'react-admin';


const ListActions = (props) => {
    const {
        className,
        exporter,
        filters,
        maxResults,
        ...rest
    } = props;
    const {
        currentSort,
        resource,
        displayedFilters,
        filterValues,
        basePath,
        showFilter,
        total,
    } = useListContext();
    const permissions = usePermissions().permissions;
    if (!permissions) {
        return null;
    }
    return (
        <TopToolbar className={className} {...sanitizeListRestProps(rest)}>
            {filters && cloneElement(filters, {
                resource,
                showFilter,
                displayedFilters,
                filterValues,
                context: 'button',
            })}
            {permissions.includes("machine_types.create") &&
                <CreateButton basePath={basePath} label="Crear" />
            }
            {permissions.includes("machine_types.export") &&
                <ExportButton
                    label="Exportar csv"
                    disabled={total === 0}
                    resource={resource}
                    sort={currentSort}
                    filterValues={filterValues}
                    maxResults={maxResults}
                />
            }
        </TopToolbar>
    );
};

export const MachineTypeList = props => (
    <List filters={<MachineTypeFilter />} {...props} title="Máquinas" actions={<ListActions />}>
        <Datagrid>
            <FunctionField render={record => `${record.type.toUpperCase()}`} label='Función' />
            <FunctionField render={record => `${record.secondType.toUpperCase()}`} label='Origen' />
            <EditButton label="Editar" />
        </Datagrid>
    </List>
);

const MachineTypeFilter = (props) => (
    <Filter {...props}>
        <TextInput label="Buscar" source="q" alwaysOn />
        <SelectInput source="type" label="Función" choices={[
            { id: 'lavadora', name: 'Lavadora' },
            { id: 'secadora', name: 'Secadora' }
        ]} />
    </Filter>
);

const MachineTypeEditToolbar = props => (
    <Toolbar {...props} >
        <SaveButton />
    </Toolbar>
);

export const MachineTypeEdit = props => {
    return (<Edit {...props}>
        <SimpleForm submitOnEnter={false} toolbar={<MachineTypeEditToolbar />}>
            <SelectInput validate={[required()]} source="type" label="Función" choices={[
                { id: 'lavadora', name: 'Lavadora' },
                { id: 'secadora', name: 'Secadora' }
            ]} />
            <TextInput source="secondType" validate={[required()]} label="Origen" />
        </SimpleForm>
    </Edit>)
};

export const MachineTypeCreate = props => {
    return (<Create {...props}>
        <SimpleForm submitOnEnter={false}>
            <SelectInput validate={[required()]} source="type" label="Función" choices={[
                { id: 'lavadora', name: 'Lavadora' },
                { id: 'secadora', name: 'Secadora' }
            ]} />
            <TextInput source="secondType" validate={[required()]} label="Origen" />
        </SimpleForm>
    </Create>)
};
